import { request } from 'umi';
import { LS_TOKEN_NAME } from '@/constants';

/** Logout POST /api/auth/logout — revokes the current device session on the backend */
export async function outLogin() {
  try {
    await request('/api/auth/logout', {
      method: 'POST',
      withToken: true,
      skipErrorHandler: true,
    });
  } catch (e) {
    // Token may already be expired/revoked; still clear it locally.
  }

  localStorage.setItem(LS_TOKEN_NAME, '');
}

/** account POST /api/auth/user */
export async function login(body: API.LoginParams, options?: { [key: string]: any }): Promise<API.LoginResult> {
  return request('/api/auth/user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...options,
    skipToken: true,
  });
}
